export default __webpack_public_path__ + "static/media/diana-home-sindico.858e1a91.png";